export class ModulesLookup {
  static readonly modules: Record<string, string> = {
    basic: 'Basic',
    'nhf.ewus': 'eWUŚ',
    'nhf.kolce': 'Kolce',
    'nhf.p1.referral': 'P1 - e-Skierowania',
    'nhf.settlements': 'Rozliczenia NFZ',
    'nhf.p1.zm': 'P1 - ZM',
    'nhf.p1.edm': 'P1 - EDM',
    'result-cda': 'Wynik CDA',
  };
}
